import React from 'react';

import Link from '../resolvers/Link';
import Container from './UI/Container';
// import ClutchBadge from './UI/ClutchBadge';
// import StripeCarbonRemoval from './UI/StripeCarbonRemoval';
import Shadow from '@/assets/shadow-footer.svg';

import Logo from '@/assets/cleancommit-logo.svg';

import nav from '@/settings/footer.json';
import Title from './UI/Title';
import Button from './UI/Button';
import SocialLinks from './UI/SocialLinks';

export default function Footer() {
  return (
    <>
      <footer className='relative mt-auto w-full overflow-hidden rounded-t-3xl bg-black text-white md:pb-0'>
        <div className='relative z-10 pb-8 pt-24 lg:pb-16 lg:pt-40'>
          <Container>
            <div className='mx-auto max-w-5xl text-center'>
              <Title variant='xl'>
                Upgrade your website, fix conversion leaks, and have the work
                pay for itself.
              </Title>
              <div className='content mx-auto mt-5 text-center text-xl text-gray-300'>
                <p>
                  Book a 15 minute call and find out what improvement we can
                  provide to your site.
                </p>
              </div>
              <Button
                button={{
                  variant: 'button',
                  url: 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2ohDhSQTyMUwbWy1EWQrI1VD4xaKf_HH1PitffYCbxcipcuWamWbwIq-CBNA9l1mYxHqQKKeWC?gv=true',
                }}
                className='mt-10'>
                Book 15-minute call with Tim
              </Button>
            </div>
          </Container>
        </div>
        <div className='relative z-10 mt-auto pt-10 text-white md:pb-0'>
          <Container>
            <hr className='border-gray-900' />
          </Container>
          <div className='py-10'>
            <Container className='flex flex-wrap justify-center gap-6 text-center sm:text-left md:justify-between'>
              {nav.nav.map((item, i) => (
                <div className='min-w-[186px] flex-1' key={i}>
                  <div className='font-heading text-md font-bold tracking-tight'>
                    {item.name}
                  </div>
                  <nav className='mt-4'>
                    {item.children.map((child, i) => (
                      <React.Fragment key={i}>
                        {child.permalink === '#' ? (
                          <div className='mb-4 mt-8 font-heading text-md font-bold tracking-tight'>
                            {child.name}
                          </div>
                        ) : (
                          <Link
                            to={child.permalink}
                            className='mb-4 line-clamp-1 text-md text-gray-400 transition-colors ease-in-out hover:text-gray-300'>
                            {child.name}
                          </Link>
                        )}
                      </React.Fragment>
                    ))}
                  </nav>
                </div>
              ))}
            </Container>
          </div>
          <Container>
            <hr className='border-gray-900' />
          </Container>
          <div className='relative z-10 py-8'>
            <Container className='flex flex-col flex-wrap items-center justify-between gap-4 md:flex-row'>
              <div>
                <Logo />
              </div>
              <div className='flex flex-col-reverse items-center gap-4 text-zinc-500 md:flex-row '>
                <div className='text-center text-xs text-gray-700 '>
                  © 2018 - {new Date().getFullYear()} Clean Commit All Rights
                  Reserved
                </div>
                <Link
                  to='/privacy-policy/'
                  className='text-xs text-gray-700 transition-colors hover:text-gray-300'>
                  Privacy policy
                </Link>
                <div className='flex gap-1'>
                  <SocialLinks />
                </div>
              </div>
            </Container>
          </div>
        </div>
        <Shadow className='absolute left-1/2 top-0 -translate-x-1/2' />
      </footer>
    </>
  );
}
